import React, { Component } from 'react';
import produce from 'immer';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import RejectExchangeModal from '../../../../views/order/common/modal/RejectExchangeModal';
import { orderActions } from '../../../../store/modules/order';
import { updateStoreWithPath } from '../../../../lib/common';
import withModal from '../../../../lib/hoc/withModal';

class RejectExchangeModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  교환 거부 상세사유
       */
      reason: null,
      /**
       *  교환 거부 상세 이미지
       */
      rejectExchangeAttachment: [],
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;

    toggleModal({
      name: 'rejectExchangeModal',
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   *  이미지 업로드
   */
  imgUpload = (data) => {
    this.setState(
      produce((draft) => {
        updateStoreWithPath(data.path, data.value, draft);
      }),
    );
  };

  /**
   *  교환 거부 하기
   */
  onSubmit = () => {
    const { form, data, rejectOrderExchange } = this.props;
    const { reason, rejectExchangeAttachment } = this.state;
    const { orderItemId, orderItemExchangeStatus } = data;

    form.validateFields((err) => {
      if (err) return;

      rejectOrderExchange({
        orderItemId,
        reason,
        rejectExchangeAttachment,
        orderItemExchangeStatus,
      });

      this.closeModal();
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <RejectExchangeModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setData={this.setData}
        imgUpload={this.imgUpload}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.rejectExchangeModal.isOpen,
    data: state.order.rejectExchangeModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  rejectOrderExchange: orderActions.rejectOrderExchange,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(RejectExchangeModalContainer)));
